var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink3Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 10C1 7.23858 3.23858 5 6 5H12C14.7614 5 17 7.23858 17 10C17 12.7614 14.7614 15 12 15C11.4477 15 11 14.5523 11 14C11 13.4477 11.4477 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7H6C4.34315 7 3 8.34315 3 10C3 11.3965 3.95512 12.5725 5.24926 12.9055C5.78411 13.0432 6.1061 13.5884 5.96844 14.1232C5.83078 14.6581 5.28559 14.9801 4.75074 14.8424C2.59442 14.2874 1 12.3312 1 10ZM12 11C10.3431 11 9 12.3431 9 14C9 15.6569 10.3431 17 12 17H18C19.6569 17 21 15.6569 21 14C21 12.6035 20.0449 11.4275 18.7507 11.0945C18.2159 10.9568 17.8939 10.4116 18.0316 9.87676C18.1692 9.34191 18.7144 9.01992 19.2493 9.15758C21.4056 9.71258 23 11.6688 23 14C23 16.7614 20.7614 19 18 19H12C9.23858 19 7 16.7614 7 14C7 11.2386 9.23858 9 12 9C12.5523 9 13 9.44772 13 10C13 10.5523 12.5523 11 12 11Z",
    fill: "#09244B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink3Line);
export default __webpack_public_path__ + "static/media/link_3_line.87a3850c6294f8e4d386c50f1f9d7594.svg";
export { ForwardRef as ReactComponent };